package com.xtream.data_kmp

import androidx.datastore.core.DataStore
import androidx.datastore.preferences.core.Preferences
import androidx.datastore.preferences.core.booleanPreferencesKey
import androidx.datastore.preferences.core.edit
import androidx.datastore.preferences.core.emptyPreferences
import androidx.datastore.preferences.core.intPreferencesKey
import androidx.datastore.preferences.core.longPreferencesKey
import androidx.datastore.preferences.core.stringPreferencesKey
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch
import kotlinx.io.IOException


const val APP_PREFERENCES_NAME = "app_preferences"

class PreferencesRepo(
      private val dataStore: DataStore<Preferences>
) {
    val readFromDataStore : Flow<UserPreferences> = dataStore.data
        .catch { exception ->
            if (exception is IOException) {
               // Log.d("DataStoreRepository", exception.message.toString())
                emit(emptyPreferences())
            } else {
                throw exception
            }
        }
        .map { preference ->
           // println("======${preference.toPreferences()}")
          return@map  UserPreferences(
                resumeLastActivityEnabled = preference[LAST_PLAYED_ACTIVITY_ENABLED_KEY] != false,// mean default is true
              lastVisitedScreen= preference[LAST_VISITED_SCREEN_KEY],

              lastUpdatedDataMillis = preference[LAST_DATA_UPDATE_MILlIS_KEY],
              lastPlayedScreen = preference[LAST_PLAYED_SCREEN_KEY] ,
                lastPlayedCategory = preference[LAST_PLAYED_CATEGORY_KEY] ,
                lastPlayedStream = preference[LAST_PLAYED_STREAM_KEY] ,
              language = preference[LANGUAGE_KEY] ,
              theme = preference[APP_THEME_KEY] ,


                forcePlayerRefreshOnUpdate = preference[FORCE_PLAYER_REFRESH_ON_UPDATE_KEY] ?:false,
              alwaysUseHTTPS = preference[ALWAYS_USE_HTTPS_KEY]?:false,

                liveStreamFormat = preference[LIVE_STREAM_FORMAT_KEY] ,
              videoScalingMode = preference[VIDEO_SCALING_MODE_KEY],
              videoRenderMode = preference[VIDEO_RENDER_MODE_KEY],
              playlistRefreshInterval = preference[PLAYLIST_REFRESH_INTERVAL_KEY],
              accountServerUrl = preference[ACCOUNT_SERVER_URL_KEY],
              activationServerUrl = preference[ACTIVATION_SERVER_URL_KEY],
              activationXORKey = preference[ACTIVATION_XOR_KEY],
              serverUserAgent = preference[SERVER_USER_AGENT_KEY],
              serverTMDBKey = preference[SERVER_TMDB_KEY],
              subtitleKey = preference[SUBTITLE_KEY],
              subtitleServer = preference[SUBTITLE_SERVER],

              trialUsername = preference[TRIAL_USER],
              trialPassword = preference[TRIAL_PASS],
              loggedInCode = preference[LOGGED_IN_CODE],
              skipAccountRefresh = false
         )
        }




     suspend fun <T> editPref(key: Preferences.Key<T>, value: T) {
        dataStore.edit { preferences ->
            preferences[key] = value
        }
    }
    suspend fun <T> clearPref(key: Preferences.Key<T>) {
        dataStore.edit { preferences ->
            preferences.remove(key) // Remove the key itself, not its value
        }
    }

    suspend fun clearDataStore() {
        dataStore.edit { preferences ->
            preferences.clear()
        }

    }
    suspend fun <T> getPref(key: Preferences.Key<T>): T? {
        val preferences = dataStore.data.first()
        return preferences[key]
    }


    fun <T> editPref(scope: CoroutineScope, key: Preferences.Key<T>, value: T?, clearPrefIfNull: Boolean = false, onDone: () -> Unit = {}) {
        scope.launch {
            if (value == null && clearPrefIfNull) {
                //Log.d("editPref", "clearPref: $clearPrefIfNull, prefKey: $key")
                clearPref(key)
            } else if (value != null) {
                editPref(key, value)
            }
            onDone()
        }
    }




    companion object{
        val  LAST_PLAYED_ACTIVITY_ENABLED_KEY:  Preferences. Key<Boolean> = booleanPreferencesKey("resumeLastPlayedActivityKey")
        val LAST_DATA_UPDATE_MILlIS_KEY:  Preferences. Key<Long> = longPreferencesKey("lastUpdatedDataMillis")
        val LAST_VISITED_SCREEN_KEY:  Preferences. Key<String> = stringPreferencesKey("lastVisitedScreenKey")
        val LAST_PLAYED_SCREEN_KEY:  Preferences. Key<String> = stringPreferencesKey("lastPlayedScreenKey")
        val LAST_PLAYED_CATEGORY_KEY:  Preferences. Key<String> = stringPreferencesKey("lastPlayedCategoryKey")
        val LAST_PLAYED_STREAM_KEY:  Preferences. Key<String> = stringPreferencesKey("lastPlayedStreamKey")
        val  FORCE_PLAYER_REFRESH_ON_UPDATE_KEY:  Preferences. Key<Boolean> = booleanPreferencesKey("forcePlayerRefreshOnUpdateKey")
        val  ALWAYS_USE_HTTPS_KEY:  Preferences. Key<Boolean> = booleanPreferencesKey("alwaysUseHTTPS")
        val  LIVE_STREAM_FORMAT_KEY:  Preferences. Key<String> = stringPreferencesKey("liveStreamFormatKey")
        val  LANGUAGE_KEY:  Preferences. Key<String> = stringPreferencesKey("languageKey")
        val  APP_THEME_KEY:  Preferences. Key<String> = stringPreferencesKey("appThemeKey")
        val VIDEO_SCALING_MODE_KEY:  Preferences. Key<Int> = intPreferencesKey("videoScalingModeKey")
        val VIDEO_RENDER_MODE_KEY:  Preferences. Key<Int> = intPreferencesKey("videoRenderModeKey")
        val PLAYLIST_REFRESH_INTERVAL_KEY:  Preferences. Key<String> = stringPreferencesKey("playlistRefreshIntervalKey")
        //configs
        val ACCOUNT_SERVER_URL_KEY:  Preferences. Key<String> = stringPreferencesKey("accountServerUrlKey")
        val ACTIVATION_SERVER_URL_KEY:  Preferences. Key<String> = stringPreferencesKey("activationServerKey")
        val ACTIVATION_XOR_KEY:  Preferences. Key<String> = stringPreferencesKey("activationXORKey")
        val SERVER_USER_AGENT_KEY:  Preferences. Key<String> = stringPreferencesKey("serverUserAgentKey")
        val SERVER_TMDB_KEY:  Preferences. Key<String> = stringPreferencesKey("serverTMDBKey")
         val SUBTITLE_KEY:  Preferences. Key<String> = stringPreferencesKey("subtitleKey")
         val SUBTITLE_SERVER:  Preferences. Key<String> = stringPreferencesKey("subtitleServer")
         val TRIAL_USER:  Preferences. Key<String> = stringPreferencesKey("trialUser")
         val TRIAL_PASS:  Preferences. Key<String> = stringPreferencesKey("trialPassword")
         val LOGGED_IN_CODE:  Preferences. Key<String> = stringPreferencesKey("subtitleServer")
         val SKIP_ACCOUNT_REFRESH:  Preferences. Key<Boolean> = booleanPreferencesKey("skipAccountRefresh")


    }

    data class UserPreferences(
        val resumeLastActivityEnabled: Boolean,
        val lastUpdatedDataMillis: Long?,
        val lastVisitedScreen: String?,
        val lastPlayedScreen: String?,
        val lastPlayedCategory: String?,
        val lastPlayedStream: String?,
        val forcePlayerRefreshOnUpdate: Boolean,
        val alwaysUseHTTPS: Boolean,
        val language: String?,
        val theme: String?,
        val liveStreamFormat: String?,
        val videoScalingMode:Int?,
        val videoRenderMode:Int?,
        val playlistRefreshInterval:String?,
        //configs
        val accountServerUrl:String?,
        val activationServerUrl:String?,
        val activationXORKey:String?,
        val serverUserAgent:String?,
        val serverTMDBKey:String?,
        val subtitleKey:String?,
        val subtitleServer:String?,
        val trialUsername:String?,
        val trialPassword:String?,
        val loggedInCode:String?,
        val skipAccountRefresh: Boolean

    )


}
